import Component from './Component';
import { checkLoginGetStatus, logoutLocal } from '../lib/OidcHelper';
import { getApiServerUrl } from '../../UM-Base/lib/TripPlannerHelper';

let apiHubUrl = '';
let thisComponent = null;  // a less painful way to pass js class "this" around.
let allSubscriptionButtonDetailsToProcess = []; // array of all subscription details
let isAllSubscriptionActionCounter = 0;
let allSubscriptionButtonDetailsToProcessPromise = null;
const testEmail = "a1aaaaaaaaaadddddssdsdssdbrdwilkinson@gmail.com";
const subScribeText = "Subscribe";
const unsubScribeText = "Unsubscribe";
const errorMessageText = "Something went wrong processing your request.";// <br/>Please <a href='#'>contact</a> the administrator.";

export default class PreferenceUnsubscribe extends Component {
  load() {
    thisComponent = this;  // store "this" on class load.

    super.load();
    this.initPreferenceSubscription();

    apiHubUrl = getApiServerUrl();

    // Only load when the panel is active
    // The below doesn't load the rest of the functions. So clicking unsubscribe doesn't work
    /*let settingsPanel = document.querySelector('.pref-centre-menu__link-text--selected')?.textContent?.toLowerCase()?.includes("settings"); // check SettingsPanel open.
    console.log("settingsPanel() - Panel work!!!!: " + settingsPanel);
    if (settingsPanel) {
      console.log("Panel feature loaded.s");
      this.initPreferenceSubscription();
    }*/
  }

  async loggedIn(user) {

    if (!!user) {
      this.unSubscribeEvent(user);
    } else {
      console.log("Preference settings page: User not loggedIn");
    }
  }

  buildSettingsPageButtons(email, token) {

      const subscriptionButton = document.querySelectorAll('.subscriptionButton');

      if (subscriptionButton) {

        subscriptionButton.forEach(button => {

            let subListId = button.getAttribute("name");
            const parentSpan = button.parentElement;

            const getSubscriptionStatusDetails = this.checkUserSubscriptionStatusOptimizely(email, subListId, token).then((data) => data).then(data => thisComponent.processSubscriptionStatusDetails(data, subListId));
            allSubscriptionButtonDetailsToProcessPromise = getSubscriptionStatusDetails;

            var subscribedTo = getSubscriptionStatusDetails;
            subscribedTo.then((isSubScribed) => {

              if (!isSubScribed) {
                button.checked = false;
                button.setAttribute("data-issubscribe", "false");
              }
              else {
                parentSpan.classList.add("jcf-checked");
                button.setAttribute("data-issubscribe", "true");
               }
            });
          });
        }
  }

  async buildManagePreferences(email, token) {

    const getCustomerPreferences = await this.processCustomerPreferencesData(email, token);

    if(getCustomerPreferences) {
      thisComponent.setActivePreferenceElement(getCustomerPreferences);
      thisComponent.manageTravellersType(email, token);
    }
  }

  async processPreferences(email, token) {
    let preferenceCheckbox = document.querySelectorAll(".preference-control-input");

    // Click event listener
    preferenceCheckbox.forEach(function(element) {
      element.addEventListener('change', function() {
        let disableSettings = document.querySelector(".pc-settings");
        if (disableSettings) {
          disableSettings.classList.add("disabled");
        }

        let buildAttributes = thisComponent.extractBuildAttributes();

        Promise.resolve(thisComponent.createUpdateProfile(buildAttributes, email, token));
        disableSettings.classList.remove("disabled");
      });
    });

    // Call extractBuildAttributes initially without a click event
    let buildAttributes = thisComponent.extractBuildAttributes();
    return buildAttributes;
  }

  extractBuildAttributes() {
    let preferenceCheckbox = document.querySelectorAll(".preference-control-input");
    let buildAttributes = {};

    preferenceCheckbox.forEach(function(control) {
      var controlId = control.id;
      var controlValue = control.checked;


      if (controlId.toLowerCase().includes("preference_traveller")) {
        buildAttributes[controlId] = control.getAttribute('value') ? true : null;

      } else if(controlId) {
        buildAttributes[controlId] = controlValue;
      }
    });

    return buildAttributes;
  }

// This fucntion can both save user information and also user preferences
async createUpdateProfile(preferenceDetails, email, token) {

    if (email && token) {
      const url = `${apiHubUrl}/api/Optimizely/CreateUpdateProfile`;

      let requestBody = {
        subscriptionType: `${siteCode}`,
          isSavePreferenceDetails: true,
          "attributes": {
            email: `${email}`
          }
      }

      Object.assign(requestBody.attributes, preferenceDetails);


     let fetchRespData = await fetch(url, {
        method: "POST",
        headers: {
          'accept': '*/*',
          'Authorization': token,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody),
        mode: "cors", // no-cors, *cors, same-origin
      }).then(res => {

        if (res && res.status != 200) {
          thisComponent.showModalContentAndTimeout(errorMessageText + "<br/>Error: Check user details is not valid: " + error.status, 12000, false);
          console.error("createUpdateProfile() Request not 200. Response:", res);
        } else {

          thisComponent.showModalContentAndTimeout("You have successfully updated your preferences", 3000, true);
          return res.json(); // translate response stream to JSON
        }
      }).then(respData => {
        return respData;

      }).catch(error => {
        console.log('POST failed: ', error);

        if (error.status == 401) {
          thisComponent.showModalContentAndTimeout(errorMessageText + "<br/>Error: Unauthorized response status code: " + error.status, 12000, false);
          console.error("createUpdateProfile() - Unauthorized response status code: ", error.status);
        }
      });
  }
}

async processCustomerPreferencesData(email , token) {
  let getCustomerPreferences = await this.getCustomerProfileAttributes(email, token);
  return getCustomerPreferences;
}

 setActivePreferenceElement(jsonData) {

  // The data containing the preferences is nested under 'data' and 'attributes'
  let preferences = jsonData;

  // We are going to loop through each of the preference keys
  for (let key in preferences) {

      // Check if the preference is set to true
      if (preferences[key] === true) {

          if (key.toLowerCase().indexOf('traveller') !== -1) {

            let travellingWithButton = document.getElementById(key);
              travellingWithButton.classList.add("travelling-with-style");
              travellingWithButton.value = true;

          } else {
              // Find the checkbox with the same id as the key
              let checkbox = document.getElementById(key);
              // If a checkbox with that id exists, check it
              if(checkbox) {
                checkbox.checked = true;
                // Get the parent span element
                const parentSpan = checkbox.parentElement;
                // Set the class of the parent span
                parentSpan.className = "jcf-checkbox jcf-checked";
              }
          }
      }
  }
}

manageTravellersType(email, token) {

  var manageTravellerTypePreference = document.getElementsByClassName('traveller-type');

  for(var i = 0; i < manageTravellerTypePreference.length; i++) {

    manageTravellerTypePreference[i].addEventListener('click', function() {
      this.classList.add("disabled");

        thisComponent.resetTravellerButtons();

          this.value = true;
          this.classList.add("travelling-with-style");

          let buildAttributes = thisComponent.extractBuildAttributes();

          Promise.resolve(thisComponent.createUpdateProfile(buildAttributes, email, token));
          this.classList.remove("disabled");
      });

  }
}

// Function to reset all buttons
resetTravellerButtons() {

  var buttons = document.getElementsByClassName('traveller-type');
  for(var i = 0; i < buttons.length; i++) {
      buttons[i].classList.remove("travelling-with-style");
      buttons[i].removeAttribute("value");
  }
}

processSubscriptionStatusDetails(data, subListId) {

  allSubscriptionButtonDetailsToProcess.push({
    list_id: subListId,
    subscribed: data
  });

  isAllSubscriptionActionCounter++;

  return data;
}

  async SubscribeUnsubcribeAll(email, token) {

    const subscribeButton = document.querySelector('#settings-subscribe-all');
    const unsubscribeButton = document.querySelector('#settings-unsubscribe-all');

    subscribeButton.addEventListener('click', function(e) {

        thisComponent.getAllSubscriptionsDetails(email, token, subScribeText.toLowerCase());
        let refreshPage = true;
        thisComponent.showModalContentAndTimeout("You have successfully " + subScribeText + ". The page will refresh now", 2000, true, refreshPage);
      });

    unsubscribeButton.addEventListener('click', function(e) {
      thisComponent.getAllSubscriptionsDetails(email, token, unsubScribeText.toLowerCase());
      allSubscriptionButtonDetailsToProcess.forEach(item => {
        thisComponent.handleClickEvent(item.list_id, email, token, unsubScribeText.toLowerCase());
      });

      let refreshPage = true;
      thisComponent.showModalContentAndTimeout("You have successfully " + unsubScribeText + ". The page will refresh now.", 2000, true, refreshPage);
    });
  }

  // Get all subscription details array and either subscribe or unsubscribe a user.
  async getAllSubscriptionsDetails(email, token, subscribeActionType) {
        // The code below is used to retrieve promise details
        await Promise.resolve(allSubscriptionButtonDetailsToProcessPromise);
        allSubscriptionButtonDetailsToProcess.forEach(item => {
          thisComponent.handleClickEvent(item.list_id, email, token, subscribeActionType);
        });
  }

  async subscriptionEvent(email, token, subscriptionType) {
    const subscriptionButtons = document.querySelectorAll('.subscriptionButton');

    if (subscriptionButtons) {
      subscriptionButtons.forEach(btn => {
            btn.addEventListener('change', function(e) {

            // // Code to handle unsubscribe button click event
            let subListId = e.target.getAttribute("name");
            console.log("subscriptionTypeAction data-issubscribeBefore", e.target.getAttribute("data-issubscribe"));
            let subscriptionTypeAction = "";
            if (e.target.getAttribute("data-issubscribe") === "true" && e.target.checked) {
              subscriptionTypeAction = "unsubscribe";
              e.target.setAttribute("data-issubscribe", false);
            } else {
              subscriptionTypeAction = "subscribe";
              e.target.setAttribute("data-issubscribe", true);
            }
            console.log("subscriptionTypeAction event", subscriptionTypeAction);
            console.log("subscriptionTypeAction data-issubscribeAfter", e.target.getAttribute("data-issubscribe"));
            thisComponent.handleClickEvent(subListId, email, token, subscriptionTypeAction, e);

          });
        });
      }
}

// Function to handle subscribe button click event
handleSubscribeClick(subListId, email, token, buttonTextSubscribe, btn, thisComponent) {

  let e = btn ? btn || window.event : null;
  let isSubscribeUserAction = true;
  let subscribeUserAction = Promise.resolve(thisComponent.subscribeUnsubscribeUserByEmail(email, subListId, token, isSubscribeUserAction));

  subscribeUserAction.then((isSubscribe) => {

    if (isSubscribe && buttonTextSubscribe && e) {
      thisComponent.showModalContentAndTimeout("You have been subscribed to " + e.target.name.toUpperCase().replaceAll("_", " ") + " mailing list.", 3000, true);
      //e.target.textContent = buttonTextSubscribe;
    }
  });
}

// Function to handle unsubscribe button click event
handleUnsubscribeClick(subListId, email, token, buttonTextSubscribe, btn, thisComponent) {

  let e = btn ? btn || window.event : null;
  let isSubscribeUserAction = false;
  let unsubscribeUserAction = Promise.resolve(thisComponent.subscribeUnsubscribeUserByEmail(email, subListId, token, isSubscribeUserAction));

  unsubscribeUserAction.then((isSubscribe) => {
    if (!isSubscribe && buttonTextSubscribe && e) {
      thisComponent.showModalContentAndTimeout("You have been unsubscribed from " + e.target.name.toUpperCase().replaceAll("_", " ") + " mailing list.", 3000, true)
      e.target.checked = false;
      e.target.parentElement.classList.remove("jcf-checked");
    }
  });
}

// Function to handle click events on subscribe/unsubscribe buttons
handleClickEvent(subListId, email, token, subscriptionType, e) {

  if (subscriptionType === "subscribe") {
    thisComponent.handleSubscribeClick(subListId, email, token, unsubScribeText, e, thisComponent);
  } else {
    thisComponent.handleUnsubscribeClick(subListId, email, token, subScribeText, e, thisComponent);
  }
}

showModalContentAndTimeout(content, timeout, isSuccess, refreshPage) {
  let modalContainer = document.getElementById('preference-unsubscribe-modal');
  var modalBody = modalContainer.getElementsByClassName('modal-body')[0];
  modalBody.innerHTML = content;
  if(isSuccess) {
    modalBody.classList.add("alert-success");
  } else if (isSuccess === false) {
    modalBody.classList.add("alert-danger");
  }

  $('#preference-unsubscribe-modal').modal('show');

    // Ensure timeout is a number and greater than 0
    if (typeof timeout !== 'number' || timeout <= 0) {
      console.error('Invalid timeout value:', timeout);
      return;
  }

  setTimeout(function() {
    $('#preference-unsubscribe-modal').modal('hide');
  }, timeout);

  if (refreshPage) {
    window.location.reload();
  }
}


// message is the message to display in the popup
// displayType is either a block or none
// timeout is in milliseconds and its used to close the popup
// refreshPage overrides the timeout of the popup message
// classColor is a class to change the style of the popup message
popupMessage(message, displayType, timeout, refreshPage, classColor) {
  const popupMessage = document.querySelector('#popupMessage');
  const closeBtn = popupMessage.querySelector('.close');

  timeout = timeout || 3000;
  popupMessage.style.display = displayType;

  //Reset the message
  const paragraphs = popupMessage.getElementsByTagName('p');
  while (paragraphs.length > 0) {
    popupMessage.removeChild(paragraphs[0]);
  }

  //A class to change the style of the popup message
  if (classColor) {
    popupMessage.classList.add(classColor);
  }

   // Add a click event listener to the close button
   closeBtn.addEventListener('click', function() {
    // Hide the popup message immediately
    popupMessage.style.display = 'none';
  });

  let p = document.createElement("p");
  p.innerHTML = message;
  popupMessage.append(p);

  setTimeout(function() {
    popupMessage.style.display = 'none';

    if (refreshPage) {
      window.location.reload();
    }
  }, timeout);
}


async checkUserSubscriptionStatusOptimizely(email, siteCode, token) {

    if (email && token) {
      const url = `${apiHubUrl}/api/Optimizely/GetUserInfo`;

      let requestBody = {
        email: `${email}`,
        subscriptionType: `${siteCode}`
      }

     let fetchRespData = await fetch(url, {
        method: "POST",
        headers: {
          'accept': '*/*',
          'Authorization': token,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody),
        mode: "cors", // no-cors, *cors, same-origin
      }).then(res => {

        if (res && res.status != 200) {
          thisComponent.showModalContentAndTimeout(errorMessageText + "<br/>Error: Check user details is not valid: " + error.status, 12000);
          console.error("Request not 200. Response:", res);
        } else {
          return res.json(); // translate response stream to JSON
        }
      }).then(respData => {
        return respData;

      }).catch(error => {
        console.log('POST failed: ', error);
        var preferenceContainer = document.getElementsByClassName("pref-subscriptions")[0];

        if (preferenceContainer) {
          preferenceContainer.textContent = "An error occurred while retrieving your subscription details. Please contact the administrator.";
          preferenceContainer.className = "alert-danger";
        }

        if (error.status == 401) {
          thisComponent.popupMessage(errorMessageText + "<br/>Error: Unauthorized response status code: " + error.status, "block", 12000);
          console.error("checkUserSubscriptionStatusOptimizely() - Unauthorized response status code: ", error.status);
        }
      });

      const checkUserStatus = obj => obj.list_id === siteCode && obj.subscribed === true;

      return fetchRespData && fetchRespData?.data?.subscriptions?.some(checkUserStatus);
  }
}

  async subscribeUnsubscribeUserByEmail(email, siteCode, token, isSubscribeAction) {

      if (email && token) {
        const url = `${apiHubUrl}/api/optimizely/subscribeUnsubscribe`;

        let requestBody = {
          email: `${email}`,
          subscriptionType: `${siteCode}`,
          isSubscribed: isSubscribeAction
        }

       let fetchRespData = await fetch(url, {
          method: "POST",
          headers: {
            'accept': '*/*',
            'Authorization': token,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestBody),
          mode: "cors", // no-cors, *cors, same-origin
        }).then(res => {

          if (res && res.status != 200) {
            console.error("subscribeUnsubscribeUserByEmail() Request not 200. Response:", res);
          } else {
            return res.json(); // translate response stream to JSON
          }
        }).then(respData => {
          return respData;

        }).catch(error => {
          console.log('POST failed: ', error);

          if (error.status == 401) {
            console.error("unSubscribeUser() - Unauthorized response status code: ", error.status);
          }
        });

        var returnResult = null;

        if (fetchRespData && fetchRespData?.data?.updates[0].subscribed === true) {
          returnResult = fetchRespData?.data.updates[0].subscribed;
        } else if (fetchRespData && fetchRespData?.data.updates[0].subscribed === false) {
          returnResult = false;
        }
        return returnResult;
    }
  }


  async getCustomerProfileAttributes(email, token) {

    if (email && token) {
      const url = `${apiHubUrl}/api/optimizely/getCustomerProfile?email=${email}`;

     let fetchRespData = await fetch(url, {
        method: "GET",
        headers: {
          'accept': '*/*',
          'Authorization': token,
          'Content-Type': 'application/json'
        },
        //body: JSON.stringify(requestBody),
        mode: "cors", // no-cors, *cors, same-origin
      }).then(res => {

        if (res && res.status != 200) {
          console.error(`getCustomerProfileAttributes() Request not 200. Response:`, res);
          var preferenceContainer = document.getElementsByClassName("pref-subscriptions");
          preferenceContainer.style.display = "none";
        } else {
          return res.json(); // translate response stream to JSON
        }
      }).then(respData => {
        return respData;

      }).catch(error => {
        console.log('GET failed: ', error);

        if (error.status == 401) {
          console.error(`getCustomerProfileAttributes()- Unauthorized response status code: `, error.status);
        }
      });

      var returnResult = null;

      if (fetchRespData && fetchRespData?.data?.attributes) {
        returnResult = fetchRespData?.data.attributes;
      }
      return returnResult;
  }
}

  // leaving this method for now until we figure out if dotdigital is needed for our purposes.
  async checkUserSubscriptionStatusDotDigital(email, siteCode, token) {

      if (email && token) {
        const url = `${apiHubUrl}/api/dotdigital/getUserInfo`;

        let requestBody = {
          email: `${email}`,
          subscriptionType: `${siteCode}`
        }

       let fetchRespData = await fetch(url, {
          method: "POST",
          headers: {
            'accept': '*/*',
            'Authorization': token,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestBody),
          mode: "cors", // no-cors, *cors, same-origin
        }).then(res => {
          console.log("Response from API");
          console.log(res);

          if (res && res.status != 200) {
            console.error("Request not 200. Response:", res);
          } else {
            return res.json(); // translate response stream to JSON
          }
        }).then(respData => {
          return respData;

        }).catch(error => {
          console.log('POST failed: ', error);

          if (error.status == 401) {
            console.error("checkUserSubscriptionStatus() - Unauthorized response status code: ", error.status);
          }
        });

        var returnResult = null;
        if (fetchRespData && fetchRespData?.data?.contact?.status?.toLowerCase() === "subscribed") {

          returnResult = true;
        } else {
          returnResult = false;
        }

        return returnResult
    }
  }
  async unSubscribeUserByEmailDotdigital(email, siteCode, token) {

    // TODO remove this email here:
    email = "testacctcountry184@umn.edu"; // "testacctcountry175@umn.edu";

      if (email && token) {
        const url = `${apiHubUrl}/api/dotdigital/unsubscribe`;

        let requestBody = {
          email: `${email}`,
          subscriptionType: `${siteCode}`
        }

       let fetchRespData = await fetch(url, {
          method: "POST",
          headers: {
            'accept': '*/*',
            'Authorization': token,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestBody),
          mode: "cors", // no-cors, *cors, same-origin
        }).then(res => {
          console.log("unSubscribeUser() Response from API");
          console.log(res);

          if (res && res.status != 200) {
            console.error("unSubscribeUser() Request not 200. Response:", res);
          } else {
            return res.json(); // translate response stream to JSON
          }
        }).then(respData => {
          return respData;

        }).catch(error => {
          console.log('POST failed: ', error);

          if (error.status == 401) {
            console.error("unSubscribeUser() - Unauthorized response status code: ", error.status);
          }
        });

        var returnResult = null;
        if (fetchRespData && fetchRespData?.data?.contact?.status?.toLowerCase() === "subscribed") {

          returnResult = true;
        } else if (fetchRespData?.data?.contact?.status?.toLowerCase() === "unsubscribed") {
          returnResult = false;
        }

        return returnResult;
    }
  }

  async initPreferenceSubscription() {

    // Check Login Status and get "user" and "token".
    let user, token;  // define variables we will destructure into.
    ({user, token} = await checkLoginGetStatus()); // destructuring object returned into variables.

      //await this.loggedIn(user);
      if (!!user) {

        // Check if function is set to true and then run the following actions below
        if(!window.location.pathname.startsWith('/preference-centre'))
          return;

          let userEmail = user.profile.email; // user.profile.email; //testEmail
          this.buildSettingsPageButtons(userEmail, token);
          this.subscriptionEvent(userEmail, token, null);
          this.SubscribeUnsubcribeAll(userEmail, token);
          this.buildManagePreferences(userEmail, token);
          this.processPreferences(userEmail, token);
      }

      // document.getElementById("toggleSwitch").addEventListener("change", function() {
      //   // Toggle your desired functionality here
      //   if (this.checked) {
      //     // Toggle switch is ON
      //     console.log("Switch is ON");
      //   } else {
      //     // Toggle switch is OFF
      //     console.log("Switch is OFF");
      //   }
      // });

      // jcf.setOptions("Checkbox", {
      //   unselectableClass: "exclude-jcf",
      //   checkedClass: "test",
      //   wrapNative: false
      // });
      // jcf.replaceAll();
      // // jcf.replace(document.querySelectorAll("input[type='checkbox']:not(.exclude-jcf)"));


  }

}
